import type { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import useUser, { isAuthorizedUser } from 'shared/hooks/use-user'
import ModuleIcon from 'shared/icons/module-icon'
import { useGetLoginUrl } from 'shared/utils/url-utils'
import { useCourseData } from 'modules/course/hooks/use-course-data'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

export const CoursePurchaseModuleScreen = ({
  moduleLink,
}: {
  moduleLink?: string | null
}): ReactNode => {
  const { t } = useTranslation()

  const { user } = useUser()
  const { courseData } = useCourseData()
  const loginUrl = useGetLoginUrl()

  const hasPurchasePage = !!(courseData?.salesPage || moduleLink)

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(
        `course__info-screen--login-and-purchase-module-or-course`,
      )}
      icon={<ModuleIcon className="size-[80px]" />}
      text={t(
        hasPurchasePage
          ? 'course.purchase_module_or_course_button'
          : 'course.module.error.access_unavailable',
      )}
      buttons={
        hasPurchasePage ? (
          <>
            {!isAuthorizedUser(user) && (
              <Button
                variant="primary"
                className={`border-THEME-secondary! bg-THEME-secondary! font-bold text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--primary', 'course__button--login'])}`}
                render={<LinkWithoutPrefetch href={loginUrl} target="_blank" />}
              >
                {t('user.profile.menu.login')}
              </Button>
            )}
            {moduleLink && (
              <Button
                variant="primary"
                className={`border-THEME-secondary! bg-THEME-secondary! font-bold text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--primary', 'course__button--purchase-module'])}`}
                render={<LinkWithoutPrefetch href={moduleLink ?? ''} target="_blank" />}
              >
                {t('course.purchase_module_button')}
              </Button>
            )}
            {courseData?.salesPage && (
              <Button
                variant="secondary"
                className={`border-THEME-primary! bg-THEME-block-background! font-bold text-THEME-primary! hover:border-THEME-block-background! hover:bg-THEME-primary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:text-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--secondary', 'course__button--purchase-course'])}`}
                render={<LinkWithoutPrefetch href={courseData.salesPage ?? ''} target="_blank" />}
              >
                {t('course.purchase_course_button')}
              </Button>
            )}
          </>
        ) : (
          <Button
            variant="primary"
            className={`border-THEME-secondary! bg-THEME-secondary! font-bold text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled! ${addPublicCustomClassNamePrefix(['course__button', 'course__button--primary', 'course__button--purchase-module'])}`}
            render={
              <LinkWithoutPrefetch
                href={`${globalThis.location.origin}/school?tab=explore_courses`}
                target="_blank"
              />
            }
          >
            {t('course.explore_button')}
          </Button>
        )
      }
    />
  )
}
